import './Card.scss';
import classNames from 'classnames';
export default function Card({ className, children }) {
  return <div className={classNames('card', className)}>{children}</div>;
}
